import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    console.log("Weryfikacja tokenu:", token);
    if (!token) {
      setStatus("error");
      setMsg("Brak tokenu weryfikacyjnego.");
      return;
    }

    api.get(`/participants/verify?token=${token}`)
      .then((r) => {
        console.log("Weryfikacja sukces:", r.data);
        setStatus("success");
        setMsg(r.data.detail);
      })
      .catch((e) => {
        console.error("Weryfikacja błąd:", e.response?.data);
        setStatus("error");
        setMsg(e.response?.data?.detail || "Wystąpił błąd podczas weryfikacji.");
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#2A2A2A] flex items-center justify-center p-5">
      <div className="bg-[#1F1F1F] border border-[#3a3a3a] p-10 md:p-16 text-center max-w-xl w-full">
        {status === "loading" && (
          <>
            <Loader2 size={64} className="text-[#FFCC00] mx-auto mb-6 animate-spin" />
            <h1 className="font-display text-white text-3xl uppercase mb-4">Weryfikacja...</h1>
            <p className="text-white/60">Proszę czekać, sprawdzamy Twój token.</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircle2 size={64} className="text-[#FFCC00] mx-auto mb-6" />
            <h1 className="font-display text-white text-3xl uppercase mb-4">E-mail potwierdzony!</h1>
            <p className="text-white/60 mb-8">{msg}</p>
            <Link to="/wejscie" className="bg-[#FFCC00] text-[#2A2A2A] font-display px-8 py-4 btn-brutal inline-block">
              ZALOGUJ SIĘ
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <XCircle size={64} className="text-red-500 mx-auto mb-6" />
            <h1 className="font-display text-white text-3xl uppercase mb-4">Błąd weryfikacji</h1>
            <p className="text-red-400/80 mb-8">{msg}</p>
            <Link to="/" className="text-[#FFCC00] font-mono-acc text-xs uppercase hover:underline">
              Powrót do strony głównej
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
